export default "__VITE_ASSET__D4du2oZ9__"